<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="6">
        <v-card :loading="loading">
          <v-card-title>Products for {{ pmsConnDetails.usr }}</v-card-title>
          <v-card-subtitle>{{ pmsConnDetails.pmsType }}</v-card-subtitle>
          <v-divider></v-divider>
          <template v-for="(prod, index) in productsExcludingMh1EasyRecalls">
            <v-list-item
              v-for="(link, index2) in prod.olbPMSInfo"
              :key="'pmsSiteProduct' + index + index2"
            >
              <v-list-item-icon>
                <v-icon>mdi-hospital-building</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ link.siteName }}</v-list-item-title>
              <v-list-item-subtitle>PMS Site</v-list-item-subtitle>
            </v-list-item>

            <v-list-item :key="'pmsSiteProductConnectiopn' + index">
              <v-list-item-icon>
                <v-icon>mdi-transit-connection</v-icon>
              </v-list-item-icon>

              <v-list-item-action v-if="prod.product == 'olb'">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      v-if="prod.platform == 'mh1'"
                      :to="{
                        name: 'ManageMh1',
                        params: {
                          sub: $route.params.sub,
                          mh1PracticeId: prod.accountId,
                        },
                      }"
                    >
                      <v-icon color="primary">mdi-cog-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Manage</span>
                </v-tooltip>
              </v-list-item-action>

              <v-list-item-action v-if="prod.product == 'olb'">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small icon @click="removeAccount(prod)">
                      <v-icon color="error">mdi-delete-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>Remove</span>
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>
            <v-list-item :key="index">
              <v-list-item-icon>
                <v-img
                  :src="require('@/assets/' + getPlatformIcon(prod.platform))"
                  width="32"
                ></v-img>
              </v-list-item-icon>
              <v-list-item-title>
                <a :href="getExternalManageURL(prod)" target="_blank">{{
                  prod.platformAccountName
                }}</a>
                <v-icon x-small class="pl-1 mt-n1">mdi-open-in-new</v-icon>
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ prod.platform | platformName }}
                {{ prod.product | productName }}
              </v-list-item-subtitle>
            </v-list-item>

            <v-divider
              v-if="index < products.length"
              :key="index + 'spacer'"
              :inset="false">
            </v-divider>
          </template>
          <v-card-actions>
            <v-spacer></v-spacer>
            <router-link :to="{ name: 'PmsConnProductAdd', params: { sub: $route.params.sub }}">
              <v-btn right color="primary" :loading="loading">Add a Product</v-btn>
            </router-link>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "@/graphql/queries";
import * as mutations from "@/graphql/mutations";

export default {
  props: {
    pmsConnDetails: Object,
    pmsInfo: Object,
    pmsInfoLoading: Boolean,
  },
  created: async function () {
    const sub = this.$route.params.sub;
    this.loading = true;
    try {
      await this.getLinks(sub);
      await this.setProducts();
    }
    finally {
      this.loading = false;
    }
    console.log("finished created async");
  },
  computed: {
    productsExcludingMh1EasyRecalls: function() {
      return this.products.filter(p => p?.product?.trim()?.toLowerCase() != "mh1easyrecalls")
    }
  },
  data: function () {
    return {
      loading: false,
      links: {},
      linksLoading: false,
      products: [],
      linksConfigured: false,
      mh1BaseUri: process.env.VUE_APP_MH1_BASE_URI,
      ccBaseUri: process.env.VUE_APP_CC_BASE_URI,
    };
  },
  filters: {
    productName: function (prodCode) {
      switch (prodCode?.trim().toLowerCase() ?? "") {
        case "olb": {
          return "Online Appointments";
          break;
        }
        case "mh1easyrecalls": {
          return "MH1 Easy Recalls";
          break;
        }
        default: {
          return prodCode;
          break;
        }
      }
    },
    platformName: function (plat) {
      switch (plat?.trim().toLowerCase() ?? "") {
        case "mh1": {
          return "MyHealth1st";
          break;
        }
        case "gbs": {
          return "GoBookings";
          break;
        }
        default: {
          return plat;
          break;
        }
      }
    },
  },
  methods: {
    getLinks: async function (sub) {
      this.linksLoading = true;
      this.linksConfigured = false;
      try {
        const result = await API.graphql(
          graphqlOperation(queries.getLinks, { sub: sub })
        );

        if ((result?.data?.getLinks?.sub ?? "") === "") {
          // it's OK if we dont' have links
          //this.handleResponseError("Get Connector Links Error", result);
          return;
        }
        this.linksConfigured = true;
        this.links = result.data.getLinks;
      } catch (err) {
        this.handleResponseError("Get Connector Links Error", err);
      } finally {
        this.linksLoading = false;
      }
    },
    setProducts: async function () {
      const products = !this.links?.accounts
        ? []
        : this.links.accounts.flatMap(async (acc) => {
            let accName = "";
            try {
              accName = await this.getPlatformAccountName(acc);
            } catch (err) {
              console.log(err);
            }

            
                     const olbPMSSiteIds = acc?.primaryPmsSiteId ? [acc?.primaryPmsSiteId]: [
                          ...new Set(          
                              acc.olbBooks  
                                .filter((b) => b.pmsBookFQId.indexOf("::") > 0)
                                .map((b) =>
                                  b.pmsBookFQId.substring(0, b.pmsBookFQId.indexOf("::"))
                                )
                          ),
                        ];
             
               console.log("olbBooksWithSite", olbPMSSiteIds);

            //// TODO
            // try get site, use site id first, then check it's olb's fq id starts with for at least one hit

            const olbPMSInfo = olbPMSSiteIds.map((siteId) => {
              const linkedPmsSite =
                this.pmsInfo?.sites?.find((s) => s.pmsSiteId == siteId) ?? {};
              console.log("got linkedPmsSite", linkedPmsSite);

              return {
                siteId: siteId,
                olbBooks: acc.olbBooks.filter((b) =>
                  b.pmsBookFQId.startsWith(`${siteId}::`)
                ),
                siteName: linkedPmsSite?.name ?? "", //this.pmsInfo?.length ?? 14//sites?.find(s => s.pmsSiteId?.trim()?.toLowerCase() == siteId)?.name ?? "Orphaned site"
              };
            });

            return acc.products.map((accProd) => {
              return {
                product: accProd,
                accountId: acc.accountId,
                platform: acc.platform,
                platformAccountName: accName,
                olbPMSInfo: olbPMSInfo,
              };
            });
          });
      console.log("awaiting", products);
      this.products = (await Promise.allSettled(products)).flatMap(
        (p) => p.value
      );
      console.log("set products", this.products);
    },
    getPlatformAccountName: async function (acc) {
      console.log("get accname for", acc);
      switch (acc?.platform?.trim()?.toLowerCase() ?? "") {
        case "mh1": {
          console.log("get mh1 accname for", acc);
          try {
            const mh1Details = await API.graphql(
              graphqlOperation(queries.getMh1PracticeDetails, {
                practiceId: Number(acc.accountId),
              })
            );
            if (!mh1Details?.data?.getMh1PracticeDetails?.name) {
              this.handleResponseError("Get Mh1 Practice Details", mh1Details);
              return "";
            }

            return mh1Details.data.getMh1PracticeDetails.name;
          } catch (err) {
            this.handleResponseError("Get Mh1 Practice Details", err);
          }
          return "";
          break;
        }
        default: {
          return acc?.platform;
          break;
        }
      }
    },
    async removeAccount(accToRemove) {
      const r = await this.$dialog.prompt({
        title: "Confirm Removal",
        text: "Please type DELETE to confirm the removal of this product.",
        type: "error",
      });

      if (r != "DELETE") {
        return;
      }

      const updatedLinksAccounts = this.links.accounts.filter(
        (acc) =>
          !(
            acc.platform === accToRemove.platform &&
            acc.accountId === accToRemove.accountId
          )
      );

      console.log("updated links accounts", accToRemove, updatedLinksAccounts);

      const linksUnchanged = JSON.parse(JSON.stringify(this.links));

      this.links.accounts = updatedLinksAccounts;
      this.links.accCount = updatedLinksAccounts.length;

      console.log("call updatelinks with ", this.links);

      try {
        const status = await API.graphql(
          graphqlOperation(mutations.updateLinks, { input: this.links })
        );

        this.$dialog.notify.info("Products updated");

        this.links = status.data.updateLinks;

        await this.setProducts();

        console.log("removeAccount result", status);
      } catch (err) {
        console.log("removeAccount error", err);

        this.links = linksUnchanged;

        const notifyResult = await this.$dialog.notify.error(
          "Error removing account",
          {
            position: "top-right",
            timeout: 5000,
            actions: [{ text: "Info", "x-small": true, color: "secondary" }],
          }
        );

        if (notifyResult == "Info") {
          this.$dialog.error({
            text: JSON.stringify(err),
            title: "Cannot save links",
            icon: "mdi-error",
          });
        }
      }
    },
    async handleResponseError(operationDescription, response) {
      console.log("handleResponseError", response);
      const notifyResult = await this.$dialog.notify.error(
        operationDescription,
        {
          position: "top-right",
          timeout: 5000,
          actions: [{ text: "Info", "x-small": true, color: "secondary" }],
        }
      );

      if (notifyResult == "Info") {
        this.$dialog.error({
          text: JSON.stringify(response?.errors || response),
          title: operationDescription,
          icon: "mdi-error",
        });
      }
    },
    getPlatformIcon: function (plat) {
      switch (plat?.trim().toLowerCase() ?? "") {
        case "mh1": {
          return "mh1_icon.png";
          break;
        }
        default: {
          return "1st_bk.png";
          break;
        }
      }
    },
    getExternalManageURL: function (acc) {
      switch (acc.platform?.toLowerCase() ?? "") {
        case "mh1":
          return `${this.mh1BaseUri}/practice/show/${acc.accountId}`;
        case "gbs":
          return `${this.ccBaseUri}/practice/show/${acc.accountId}`;
        default:
          return "";
      }
    },
  },
};
</script>